export const GET_ORGANIZATION_FSP_OVERVIEW_START =
  'GET_ORGANIZATION_FSP_OVERVIEW_START';
export const GET_ORGANIZATION_FSP_OVERVIEW_SUCCESS =
  'GET_ORGANIZATION_FSP_OVERVIEW_SUCCESS';
export const GET_ORGANIZATION_FSP_OVERVIEW_ERROR =
  'GET_ORGANIZATION_FSP_OVERVIEW_ERROR';
